import React from 'react';
import { render } from 'react-dom';
import './css/main.scss';

import App from './components/App.jsx';

render(<App />, document.getElementById('root'));
